import { mode } from '@chakra-ui/theme-tools';
export const buttonStyles = {
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'semibold',
        borderRadius: '8px',
        fontSize: 'sm',
        transition: 'all 0.18s cubic-bezier(0.4, 0, 0.2, 1)',
        _focus: { boxShadow: '0 0 0 3px rgba(99,102,241,0.35)' },
        _active: { transform: 'scale(0.98)' },
      },
      variants: {
        // Primary: indigo gradient — premium elegant CTA
        primary: {
          bgGradient: 'linear(to-b, brand.500, brand.600)',
          color: 'white',
          boxShadow: '0 2px 6px rgba(99,102,241,0.28), 0 1px 2px rgba(15,23,42,0.10)',
          _hover: {
            bgGradient: 'linear(to-b, brand.400, brand.600)',
            transform: 'translateY(-1px)',
            boxShadow: '0 8px 22px rgba(99,102,241,0.45), 0 2px 6px rgba(99,102,241,0.28)',
          },
          _active: { bgGradient: 'linear(to-b, brand.600, brand.700)', transform: 'scale(0.98) translateY(0)', boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.18)' },
        },
        navy: {
          bgGradient: 'linear(to-b, navy.700, navy.900)',
          color: 'white',
          boxShadow: '0 1px 3px rgba(27,37,75,0.25)',
          _hover: {
            bgGradient: 'linear(to-b, navy.600, navy.800)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 16px rgba(27,37,75,0.40)',
          },
          _active: { bgGradient: 'linear(to-b, navy.800, navy.900)', transform: 'scale(0.98) translateY(0)', boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.18)' },
        },
        'no-effects': {
          _hover: 'none',
          _active: 'none',
          _focus: 'none',
        },
        danger: () => ({
          color: 'white',
          bgGradient: 'linear(to-b, red.400, red.600)',
          boxShadow: '0 1px 3px rgba(220,38,38,0.20)',
          _hover: {
            bgGradient: 'linear(to-b, red.500, red.700)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 14px rgba(220,38,38,0.40)',
          },
          _active: { bgGradient: 'linear(to-b, red.600, red.800)', transform: 'scale(0.98) translateY(0)' },
        }),
        outlined: props => ({
          color: mode('brand.700', 'brand.300')(props),
          bg: 'transparent',
          border: '1px solid',
          borderColor: mode('brand.400', 'brand.400')(props),
          _hover: {
            bg: mode('brand.50', 'whiteAlpha.100')(props),
            borderColor: mode('brand.500', 'brand.300')(props),
          },
          _active: { bg: mode('brand.100', 'whiteAlpha.200')(props) },
        }),
        // Alias for existing code that uses "outlined"
        outline: props => ({
          color: mode('brand.700', 'brand.300')(props),
          bg: 'transparent',
          border: '1px solid',
          borderColor: mode('brand.400', 'brand.400')(props),
          _hover: {
            bg: mode('brand.50', 'whiteAlpha.100')(props),
            borderColor: mode('brand.500', 'brand.300')(props),
          },
          _active: { bg: mode('brand.100', 'whiteAlpha.200')(props) },
        }),
        dark: props => ({
          color: 'white',
          bg: mode('gray.700', 'brand.500')(props),
          _hover: {
            bg: mode('gray.600', 'brand.400')(props),
            transform: 'translateY(-1px)',
          },
          _active: { bg: mode('gray.800', 'brand.600')(props), transform: 'translateY(0)' },
        }),
        light: props => ({
          color: mode('gray.700', 'gray.700')(props),
          bg: mode('gray.100', 'white')(props),
          _hover: {
            bg: mode('gray.200', 'gray.50')(props),
            transform: 'translateY(-1px)',
          },
          _active: { bg: mode('gray.300', 'gray.100')(props), transform: 'translateY(0)' },
        }),
        // Subtle: emerald-tinted soft action
        subtle: props => ({
          color: mode('brand.700', 'brand.300')(props),
          bg: mode('brand.50', 'whiteAlpha.100')(props),
          _hover: {
            bg: mode('brand.100', 'whiteAlpha.200')(props),
          },
          _active: { bg: mode('brand.200', 'whiteAlpha.300')(props) },
        }),
        ghost: props => ({
          color: mode('gray.600', 'gray.300')(props),
          bg: 'transparent',
          _hover: {
            bg: mode('gray.100', 'whiteAlpha.100')(props),
          },
          _active: { bg: mode('gray.200', 'whiteAlpha.200')(props) },
        }),
        // Glass: backdrop-blur CTA — for use on hero/header areas with image bg
        glass: {
          bg: 'rgba(255,255,255,0.15)',
          backdropFilter: 'blur(12px)',
          border: '1px solid rgba(255,255,255,0.30)',
          color: 'white',
          fontWeight: 'semibold',
          _hover: {
            bg: 'rgba(255,255,255,0.25)',
            borderColor: 'rgba(255,255,255,0.50)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          },
          _active: { bg: 'rgba(255,255,255,0.10)', transform: 'scale(0.98)' },
        },
      },
    },
  },
};
